import { createFileRoute } from '@tanstack/react-router'

import { WorkflowEvaluationPage } from '#/modules/ai/back-office/workflow-evaluation-page/workflow-evaluation-page.tsx'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/bo/ai/evaluations/$workflowId/')({
  beforeLoad: ({ context }) => requirePermissions(context, ['aiAnalysis.review.read']),
  component: function Component() {
    const { workflowId } = Route.useParams()
    return <WorkflowEvaluationPage workflowId={workflowId} />
  },
})
